'use client';

import { PopupList, useModal } from '@payloadcms/ui';

import { IMPORT_JOURNEY_MODAL_SLUG } from '../Modals/ImportModal/ImportModal';

const ImportButton = ({ disabled }: { disabled: boolean }) => {
  const { openModal } = useModal();

  return (
    <>
      <PopupList.Button
        disabled={disabled}
        onClick={() => {
          openModal(IMPORT_JOURNEY_MODAL_SLUG);
        }}
      >
        Import
      </PopupList.Button>
    </>
  );
};

export default ImportButton;
